export interface Article {
  slug: string;
  image: string;
}

export const articles: Article[] = [
  {
    slug: "usfans-spreadsheet-list",
    image:
      "https://readdy.ai/api/search-image?query=A%20neat%20grid%20of%20assorted%20fashion%20products%20including%20sneakers%20a%20folded%20t-shirt%20a%20cap%20and%20a%20small%20bag%20arranged%20on%20a%20bright%20white%20desk%20beside%20an%20open%20laptop%20showing%20a%20clean%20spreadsheet%2C%20soft%20natural%20light%2C%20modern%20online%20shopping%20concept%2C%20crisp%20and%20airy&width=800&height=450&seq=article-list-01&orientation=landscape",
  },
  {
    slug: "usfans-seller-spreadsheet",
    image:
      "https://readdy.ai/api/search-image?query=A%20tidy%20workspace%20with%20a%20laptop%20displaying%20a%20seller%20directory%20and%20a%20few%20product%20samples%20scattered%20around%2C%20warm%20daylight%2C%20organized%20online%20marketplace%20concept%2C%20soft%20neutral%20tones%2C%20clean%20and%20professional&width=800&height=450&seq=article-seller-01&orientation=landscape",
  },
  {
    slug: "how-to-use-usfans-spreadsheet",
    image:
      "https://readdy.ai/api/search-image?query=Close-up%20of%20hands%20typing%20on%20a%20laptop%20with%20a%20product%20spreadsheet%20on%20screen%20and%20a%20coffee%20cup%20beside%2C%20bright%20modern%20home%20office%2C%20warm%20natural%20light%2C%20focused%20and%20friendly%20productivity%20concept&width=800&height=450&seq=article-howto-01&orientation=landscape",
  },
  {
    slug: "usfans-product-research",
    image:
      "https://readdy.ai/api/search-image?query=A%20magnifying%20glass%20resting%20over%20a%20flat%20lay%20of%20a%20white%20sneaker%20a%20watch%20and%20a%20folded%20hoodie%20on%20a%20soft%20cream%20background%2C%20bright%20studio%20light%2C%20product%20research%20concept%2C%20clean%20and%20detailed&width=800&height=450&seq=article-product-research-01&orientation=landscape",
  },
  {
    slug: "usfans-seller-research",
    image:
      "https://readdy.ai/api/search-image?query=A%20five-star%20rating%20and%20review%20cards%20floating%20beside%20a%20small%20stack%20of%20folded%20clothing%20on%20a%20light%20sage%20background%2C%20soft%20studio%20light%2C%20trust%20and%20seller%20review%20concept%2C%20minimal%20and%20modern&width=800&height=450&seq=article-seller-research-01&orientation=landscape",
  },
  {
    slug: "usfans-shipping-guide",
    image:
      "https://readdy.ai/api/search-image?query=A%20stack%20of%20three%20kraft%20cardboard%20shipping%20boxes%20tied%20with%20twine%20beside%20a%20rolled%20measuring%20tape%20on%20a%20warm%20beige%20surface%2C%20soft%20natural%20light%2C%20delivery%20and%20shipping%20concept%2C%20clean%20and%20tidy&width=800&height=450&seq=article-shipping-01&orientation=landscape",
  },
  {
    slug: "usfans-coupon-guide",
    image:
      "https://readdy.ai/api/search-image?query=A%20bright%20coupon%20ticket%20with%20a%20percentage%20symbol%20next%20to%20a%20folded%20sweater%20and%20a%20shopping%20bag%20on%20a%20soft%20peach%20background%2C%20soft%20studio%20light%2C%20savings%20and%20discount%20concept%2C%20fresh%20and%20cheerful&width=800&height=450&seq=article-coupon-01&orientation=landscape",
  },
  {
    slug: "usfans-discount-code-guide",
    image:
      "https://readdy.ai/api/search-image?query=A%20gift%20tag%20with%20a%20promotional%20code%20beside%20a%20pair%20of%20sneakers%20and%20a%20small%20wallet%20on%20a%20mint%20background%2C%20bright%20even%20light%2C%20discount%20shopping%20concept%2C%20clean%20and%20inviting&width=800&height=450&seq=article-discount-01&orientation=landscape",
  },
  {
    slug: "usfans-warehouse-guide",
    image:
      "https://readdy.ai/api/search-image?query=A%20bright%20warehouse%20aisle%20with%20neatly%20stacked%20boxes%20on%20industrial%20shelves%2C%20soft%20overhead%20light%2C%20clean%20and%20organized%20logistics%20concept%2C%20minimal%20and%20modern&width=800&height=450&seq=article-warehouse-01&orientation=landscape",
  },
  {
    slug: "usfans-qc-guide",
    image:
      "https://readdy.ai/api/search-image?query=A%20clipboard%20with%20a%20checklist%20and%20a%20pair%20of%20sneakers%20under%20inspection%20beside%20a%20small%20ruler%20on%20a%20clean%20white%20surface%2C%20bright%20studio%20light%2C%20quality%20control%20concept%2C%20precise%20and%20tidy&width=800&height=450&seq=article-qc-01&orientation=landscape",
  },
];